import "core-js/modules/es.array.map";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
*/
import Immutable from 'immutable';
import WFCmsRecord from '../../records/WFCmsRecord'; // fetchResult is  is a JSON object received from backend.
// Each property of the JSON is a cms entry (with the exception of "viewName")
// where the key is the cms id and the value is the cms data.

export var adapter = function adapter(fetchResult) {
  try {
    return Immutable.Map(fetchResult).asMutable() // in some cases, JSON contains extraneous "viewName" property which is not a cms entry
    ["delete"]('viewName') // the cms data may itself be  another "stringified" JSON so must be parsed if that's the case
    .map(function (cmsData) {
      return typeof cmsData === 'string' ? JSON.parse(cmsData) : cmsData;
    }).map(function (cmsData) {
      return cmsData.pageTemplate || cmsData.component ? cmsData : {
        'component': cmsData
      };
    }).map(function (cmsData, key) {
      return WFCmsRecord({
        cmsId: key,
        isFetching: false,
        data: cmsData
      });
    }).asImmutable();
  } catch (error) {
    console.error('wfui-digital-core:data-adapter - error parsing cms content', error);
    return Immutable.Map({});
  }
};